import {
    IBaseModelProps,
    IBaseModelStyle,
} from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/base-model-props.interface';
import { IBackgroundFillInfo } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import {
    ISlideSizeProps,
} from '@src/slide/domain/ui-model/element-modeles/property/slide-size/slide-size.interface';

export interface IPresentationModelStyle extends IBaseModelStyle {
    fillBackground: IBackgroundFillInfo,
}

export interface IPresentationModelProps extends IBaseModelProps, ISlideSizeProps {
}


export const DefaultSize = {
    width: 720,
    height: 540,
};
